import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    errorEmail: "Impossible d'accéder à l'adresse mail fournie pour l'inscription pour envoyer un message.",
    errorUser: "L'email fourni pour l'inscription est déjà utilisé par un autre utilisateur de l'application.",
    errorUnknown: "Une erreur inconnue s'est produite lors de la vérification de votre adresse mail.",
    saveBtn: { "label": "Enregistrer" },
    saveUnknownError: "Problème lors de l'inscription - Veuillez réessayer ultérieurement",
    html: {
        instructionText: "Une fois votre inscription effectuée, vous pourrez accéder à la plateforme pour la prise de rendez-vous et suivre vos séances et programmes prescrits sur l'application mobile ActivMed !"
    }
};

export type I18nPatientRegistration = typeof _fr;

const _en: I18nPatientRegistration = {
    errorEmail: "Provided email address is unreachable",
    errorUser: "Provided email address is already used by another user of the application",
    errorUnknown: "An unknown error as occurred during provided email check",
    saveBtn: { "label": "Save" },
    saveUnknownError: "Error during registration - Please retry later",
    html: {
        instructionText: "Once your registration accepted, you will be able to access the platform for appointment management, as well as the Activmed mobile app to follow your prescribed sessions / programs."
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nPatientRegistration {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}